export const MenuList = (loopMenu) => {
    let functionalities = [];

    for (let i = 0; i < loopMenu.length; i++) {
        const menu = loopMenu[i]

        if (menu.hasOwnProperty("children") && menu.children.length > 0) {
            const arrayToPush = MenuList(menu.children);
            functionalities.push(...arrayToPush, menu);
        } else {
            functionalities.push(menu)
        }
    }

    return functionalities
}